<template>
  <v-card 
    v-if="item && Object.keys(item).length > 0" 
    :color="item.color || 'grey lighten-4'"
    :disabled="item.disabled" 
    class="w-100" 
    elevation="0"
    variant="tonal"
  >
    <v-card-text class="py-1 px-2 d-flex align-center">
      <v-icon
        :icon="item.icon"
        :color="item.color"
        class="mr-2"
        size="x-small"
      />
      <span class="text-caption font-weight-medium black--text">
        {{ item.text }}
      </span>
      <v-spacer />
      <slot name="actions" />
    </v-card-text>
    <v-divider
      v-if="!item.disabled"
      :thickness="1"
    />
  </v-card>

  <v-card
    v-else
    color="grey lighten-4"
    class="w-100"
    elevation="0"
  >
    <v-card-text class="py-1 px-2 text-center">
      <span class="text-caption grey--text">Nenhum item selecionado</span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ItemCard',
  
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
